/**
 * Returns the extension of the file, if it doesn't have an extension
 * returns the filename
 */
export function extractExtension(filename: string) {
  let cnt: number = filename.length - 1;
  while (filename.charAt(cnt) !== "." && cnt >= 0) {
    cnt--;
  }
  return filename.slice(cnt, filename.length);
}

export function extractExtensionRemoveDot(filename: string) {
  let cnt: number = filename.length - 1;
  while (filename.charAt(cnt) !== "." && cnt >= 0) {
    cnt--;
  }
  return filename.slice(cnt + 1, filename.length);
}

/**
 * Returns the filename without the file extension
 */
export function removeExtension(filename: string) {
  const lastDotIndex = filename.lastIndexOf(".");

  if (lastDotIndex === -1) {
    return filename;
  }

  return filename.slice(0, lastDotIndex);
}

export function anyOfType(filename: string, extensions: string[]): boolean {
  if (!filename) return false;
  const ext = extractExtensionRemoveDot(filename);
  return extensions.findIndex((e) => e === ext) !== -1;
}
